import React,{useEffect,useRef,useState} from 'react';
import {Button,CircularProgress,Typography} from '@mui/material';
import VolumeUpRounded from '@mui/icons-material/VolumeUpRounded';
import StopRounded from '@mui/icons-material/StopRounded';
import api from '../../services/api';
import {ownAssistantPlayback} from './AssistantPlayback';
export function localSpeechChunks(text,max=900){
  const words=String(text).replace(/https?:\/\/\S+/g,'').split(/\s+/),parts=[];let part='';
  for(const word of words){if(part&&part.length+word.length+1>max){parts.push(part);part='';}part+=(part?' ':'')+word;}
  if(part)parts.push(part);return parts;
}
export default function ListenButton({text,conversationId,messageId,identityKey,disabled=false}){
  const [state,setState]=useState('idle'),[error,setError]=useState('');
  const audio=useRef(null),url=useRef(null),abort=useRef(null),version=useRef(0),mounted=useRef(true),release=useRef(null),utterances=useRef([]);
  const stop=()=>{
    version.current++;abort.current?.abort();abort.current=null;
    if(audio.current){audio.current.onended=null;audio.current.onerror=null;audio.current.pause();audio.current.src='';audio.current=null;}
    if(url.current){URL.revokeObjectURL(url.current);url.current=null;}
    window.speechSynthesis?.cancel();utterances.current=[];release.current?.();release.current=null;
    if(mounted.current)setState('idle');
  };
  useEffect(()=>{
    mounted.current=true;setState('idle');setError('');
    const hide=()=>{if(document.hidden)stop();};document.addEventListener('visibilitychange',hide);
    return()=>{mounted.current=false;stop();document.removeEventListener('visibilitychange',hide);};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[conversationId,messageId,identityKey]);
  const play=async token=>{
    try{audio.current.currentTime=0;await audio.current.play();if(mounted.current&&version.current===token)setState('playing');}
    catch(err){
      if(mounted.current&&version.current===token){
        if(err.name==='NotAllowedError'){setState('ready');setError('Audio pronto. Premi Ascolta per riprodurlo sul dispositivo.');}
        else{stop();setError('Il browser non riesce a riprodurre l’audio di Gas. Ricarica la pagina e riprova.');}
      }
    }
  };
  const speak=async()=>{
    if(disabled||abort.current)return;
    if(state==='playing'||state==='local'){stop();return;}
    if(state==='ready'&&audio.current){setError('');await play(version.current);return;}
    release.current=ownAssistantPlayback(stop);const token=++version.current;setError('');
    if(!conversationId||!messageId){setError('Risposta non disponibile per l’ascolto centralizzato.');return;}
    try{audio.current=new Audio();}catch(_){setError('Riproduzione audio non disponibile su questo dispositivo.');return;}
    const controller=new AbortController();abort.current=controller;setState('preparing');
    try{
      const result=await api.post(`/ai/assistant/conversations/${conversationId}/messages/${messageId}/speech`,{},{responseType:'blob',signal:controller.signal,timeout:190000});
      if(!mounted.current||version.current!==token)return;
      const blob=result.data instanceof Blob?result.data:new Blob([result.data],{type:'audio/wav'});
      if(!blob.size)throw Error('Audio non disponibile.');
      url.current=URL.createObjectURL(blob);audio.current.src=url.current;
      audio.current.onended=()=>{if(mounted.current&&version.current===token)setState('ready');};
      audio.current.onerror=()=>{if(mounted.current&&version.current===token){setState('idle');setError('Non riesco a riprodurre l’audio. Riprova.');}};
      abort.current=null;await play(token);
    }catch(err){
      if(!mounted.current||version.current!==token||controller.signal.aborted)return;
      let message=err.response?.data;
      if(message instanceof Blob){try{message=JSON.parse(await message.text());}catch(_){message=null;}}
      if(!mounted.current||version.current!==token)return;
      stop();setError(message?.error||'Voce di Gas non disponibile. Puoi riprovare o usare esplicitamente la voce del dispositivo.');
    }finally{if(version.current===token)abort.current=null;}
  };
  const local=()=>{
    if(disabled)return;
    release.current=ownAssistantPlayback(stop);const token=++version.current;setError('');
    const voices=window.speechSynthesis?.getVoices().filter(v=>v.lang.toLowerCase().startsWith('it'))||[],voice=voices.find(v=>v.localService)||voices[0];
    if(!voice){setError('Nessuna voce italiana disponibile sul dispositivo.');return;}
    utterances.current=localSpeechChunks(text).map(part=>{const item=new SpeechSynthesisUtterance(part);item.lang='it-IT';item.voice=voice;item.onerror=()=>{if(mounted.current&&version.current===token)setState('idle');};return item;});
    if(!utterances.current.length)return;
    utterances.current.at(-1).onend=()=>{if(mounted.current&&version.current===token)setState('idle');};setState('local');utterances.current.forEach(item=>window.speechSynthesis.speak(item));
  };
  return <div className="gas-listen"><Button size="small" disabled={disabled||state==='preparing'} startIcon={state==='preparing'?<CircularProgress size={14}/>:state==='playing'||state==='local'?<StopRounded/>:<VolumeUpRounded/>} onClick={speak}>{state==='preparing'?'Preparo la voce…':state==='playing'||state==='local'?'Interrompi':'Ascolta'}</Button>{state==='preparing'&&<Button size="small" onClick={stop}>Annulla lettura</Button>}<Typography variant="caption" color="text.secondary">{state==='local'?'Voce del dispositivo':'Voce AI di Gas'}</Typography>{error&&<div role="status"><Typography variant="caption">{error}</Typography>{window.speechSynthesis&&<Button size="small" disabled={disabled} onClick={local}>Usa voce del dispositivo</Button>}</div>}</div>;
}
